module.exports = __webpack_public_path__ + "img/error.129d29b9.png";